import * as moment from 'moment';
import {environment} from '../../../../environments/environment';
import {Observable} from "rxjs";

export const PDF = 'application/pdf';
export const defaultDateFormat = 'DD.MM.YYYY';
export const defaultDateTimeFormat = 'DD.MM.YYYY | HH:mm';

export const transformDate = (date: string): string => {
  const md = moment(date, [defaultDateFormat, 'YYYY.MM.DD', 'YYYY-MM-DD']);
  return md.isValid() ? md.format(defaultDateFormat) : date;
};

export const capitalizeWord = (w: string): string => (w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());

export const capitalize = (str: string): string => {
  const arr = str.split(' ').map(w => capitalizeWord(w));
  return arr.join(' ');
};

export const capitalizeFullName = (fullName) => (capitalize(`${fullName.last} ${fullName.first.charAt(0)}. ${fullName.middle.charAt(0)+'.' || ''}` ));

export const notEmptyRegex = /^$|\s+/;

export const autoDownloadFile = (data, type) => {
  const blob = new Blob([data], {type});
  const blobURL = window.URL.createObjectURL(blob);
  console.log('autoDownloadFile started')
  window.open(blobURL);
}
export function openBlobWithPreopenedWindow(
    request$: Observable<Blob>,
    type: string,
    onFinally?: () => void
) {
    // ⬅️ КРИТИЧЕСКИ ВАЖНО: открыть окно сразу (user gesture)
    const win = window.open();

    request$.subscribe({
        next: (res: Blob) => {
            const blob = res instanceof Blob ? res : new Blob([res], { type });
            const url = URL.createObjectURL(blob);

            if (win) {
                // ✅ ВАЖНО: именно window.open(url), а не location.href
                win.location.replace(url);
            } else {
                // fallback — старое поведение
                window.open(url);
            }

            setTimeout(() => URL.revokeObjectURL(url), 60_000);
        },
        error: () => {
            try { win?.close(); } catch {}
        },
        complete: () => {
            onFinally?.();
        }
    });
}

function writeLoadingToPopup(popup: Window | null, text = 'Загрузка документа…') {
  if (!popup) return;
  try {
    popup.document.open();
    popup.document.write(`
      <!doctype html>
      <html><head><meta charset="utf-8"><title>Loading</title></head>
      <body style="font-family: Arial; padding: 16px;">
        <div>${text}</div>
      </body></html>
    `);
    popup.document.close();
  } catch {
    // некоторые браузеры могут запрещать document.write
  }
}
// export const autoDownloadFile = (data: BlobPart, type: string, filename = 'file.pdf') => {
//   const blob = new Blob([data], { type });
//   const blobURL = URL.createObjectURL(blob);
//
//   const a = document.createElement('a');
//   a.href = blobURL;
//   a.download = filename;
//   a.rel = 'noopener';
//   a.click();
//
//   setTimeout(() => URL.revokeObjectURL(blobURL), 60_000);
// };
export const PLEDGE_ID = environment.contractIDS.PLEDGE_ID;
export const CESSION_ID = environment.contractIDS.CESSION_ID;
export const HOME_ID = environment.contractIDS.HOME_ID;
export const AUTO_ID = environment.contractIDS.AUTO_ID;

export const isDocumentWithPayment = (docId) => ( docId === PLEDGE_ID || docId === CESSION_ID || docId === HOME_ID || docId === AUTO_ID);

export const isAuto = (docId) => (docId === AUTO_ID);

export const iinValidator = '^([0-9]{1}|[0-9]{2}|[0-9]{3}|[0-9]{4}|[0-9]{5}|[0-9]{6}|[0-9]{7}|[0-9]{8}|[0-9]{9}|[0-9]{10}|[0-9]{11}|[0-9]{12})$';

export const defaultError = 'Errors.Service temporarily unavailable, try again later';
export const sessionExpired = 'Errors.Session expired';

// export const IDP_LINK = `${environment.authUrl}/idp/login?lvl=2&url=${window.location.href}/#/login/`;

/**
 * Права, которые запрашиваем у IDP. Без них выданный токен не даёт читать
 * /idp/resource/user/basic, и бэк не может узнать, кто вошёл.
 * Передаются через пробел (в URL — %20).
 */
export const IDP_SCOPES = 'user:basic:read user:phone:read';

/** Ключ, под которым храним state между уходом на IDP и возвратом (защита от CSRF). */
export const IDP_STATE_STORAGE_KEY = 'idp_state';

/**
 * Ссылка на вход в IDP. Собирается на каждый клик, потому что state одноразовый.
 * redirect_uri НЕ percent-кодируется: IDP сверяет его как сырую строку.
 */
export function buildIdpLink(): string {
  const state = `${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
  try {
    sessionStorage.setItem(IDP_STATE_STORAGE_KEY, state);
  } catch (e) {
    // приватный режим браузера — вход всё равно должен работать
  }
  const params = [
    'response_type=code',
    'client_id=smartcontract',
    `scope=${encodeURIComponent(IDP_SCOPES)}`,
    `state=${encodeURIComponent(state)}`,
    `redirect_uri=${environment.frontUrl}`,
  ];
  return `${environment.authUrl}/idp/oauth/authorize?${params.join('&')}`;
}
